export default ['/products/choose-your-own-story'];



// WEBPACK FOOTER //
// ./src/constants/RoutesWithoutFooterExtras.js